import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const SodaFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 258.914062 221.132812 C 259.914062 219.515625 260.679688 217.765625 261.203125 215.941406 L 276.828125 161.269531 C 279.429688 152.15625 287.863281 145.953125 297.34375 146.171875 L 505.207031 151.003906 L 696.378906 146.105469 C 703.78125 145.914062 710.730469 149.667969 714.625 155.964844 L 773.035156 250.285156 C 775 253.464844 776.078125 257.117188 776.144531 260.859375 L 791.53125 1086.320312 C 791.617188 1090.957031 790.15625 1095.5 787.371094 1099.203125 L 761.304688 1133.945312 C 760.710938 1134.738281 760.066406 1135.488281 759.371094 1136.183594 L 714.4375 1181.101562 C 710.53125 1185.007812 705.230469 1187.203125 699.703125 1187.203125 L 327.835938 1187.203125 C 324.601562 1187.203125 321.410156 1186.453125 318.515625 1185.007812 L 274.242188 1162.878906 C 271.988281 1161.742188 269.957031 1160.222656 268.25 1158.363281 L 213.960938 1099.578125 C 210.347656 1095.664062 208.371094 1090.507812 208.441406 1085.175781 L 218.675781 292.136719 C 218.722656 288.375 219.792969 284.695312 221.765625 281.488281 Z M 258.914062 221.132812 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 307.722656 1166.167969 L 500.003906 1170.53125 L 692.523438 1166.167969 C 692.523438 1166.167969 696.15625 1161.332031 699.777344 1156.742188 C 702.679688 1152.878906 705.820312 1148.765625 709.453125 1145.382812 C 715.25 1139.820312 722.515625 1136.183594 730.492188 1131.832031 C 746.695312 1123.625 767.976562 1112.734375 767.976562 1082.273438 L 767.976562 307.777344 C 767.976562 300.054688 758.0625 282.890625 746.941406 263.546875 C 729.765625 233.796875 710.179688 199.707031 710.179688 169.480469 C 710.179688 167.0625 710.660156 164.644531 711.628906 162.460938 L 288.371094 162.460938 C 289.335938 164.644531 289.820312 167.0625 289.820312 169.480469 C 289.820312 199.707031 270.238281 233.796875 253.058594 263.546875 C 241.9375 282.890625 232.023438 300.054688 232.023438 307.777344 L 232.023438 1082.273438 C 232.023438 1112.734375 253.308594 1123.625 269.503906 1131.832031 C 277.730469 1136.183594 284.988281 1139.820312 290.785156 1145.382812 C 294.421875 1148.765625 297.316406 1152.878906 300.46875 1156.742188 C 303.855469 1161.332031 307.488281 1166.167969 307.722656 1166.167969 Z M 499.761719 1204.617188 L 307 1200.273438 C 290.554688 1199.78125 281.605469 1188.421875 273.371094 1177.539062 C 271.207031 1174.632812 269.023438 1171.730469 267.332031 1170.042969 C 265.15625 1167.863281 259.835938 1165.207031 254.027344 1162.304688 C 229.84375 1149.734375 197.917969 1133.289062 197.917969 1082.273438 L 197.917969 307.777344 C 197.917969 291.34375 210.011719 270.300781 223.554688 246.613281 C 236.609375 224.125 251.367188 198.734375 254.992188 178.179688 C 251.367188 174.070312 249.191406 168.75 249.191406 162.945312 L 249.191406 151.828125 C 249.191406 145.546875 251.859375 139.496094 256.210938 135.378906 C 260.316406 131.03125 266.367188 128.378906 272.890625 128.378906 L 727.347656 128.378906 C 733.882812 128.378906 739.683594 131.03125 744.039062 135.378906 C 748.148438 139.496094 750.8125 145.546875 750.8125 151.828125 L 750.8125 162.945312 C 750.8125 168.75 748.628906 174.070312 745.246094 178.179688 C 748.871094 198.734375 763.386719 224.125 776.445312 246.613281 C 789.996094 270.300781 802.082031 291.34375 802.082031 307.777344 L 802.082031 1082.273438 C 802.082031 1133.289062 770.402344 1149.734375 746.214844 1162.304688 C 740.417969 1165.207031 735.089844 1167.863281 732.917969 1170.042969 C 731.214844 1171.730469 729.039062 1174.632812 726.628906 1177.539062 C 718.402344 1188.421875 709.453125 1199.78125 693.246094 1200.273438 Z M 499.761719 1204.617188 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="350.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
